import React, {useState, useEffect, useContext} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import {OrderFormContext} from '../../contexts'

function SelectOption({option, onChange, isSelected, isGrayOut, onHover, onLeave, isAussieMade, attributeCode}) {
    const optionName = option.label || option.value

    const onKeyPress = (e, option) => {
        if (e.key === 'Enter') {
            onChange(option)
        }
    }

    const _isPackagedPrintsPaperType = () => {
        return 'packaged-prints-paper-type' === attributeCode
    }

    const _getQtySetByOptionValue = _value => {
        return ['Satin', 'Matte Art paper', 'Economy'].includes(_value) ? 20 : 10
    }

    return (
        <li
            key={option.id}
            onMouseEnter={() => onHover(option)}
            onMouseLeave={onLeave}
            role="button"
            tabIndex="0"
            className={
                classnames('PaSelectOption', {
                    Selected: isSelected(option),
                    GrayOut: isGrayOut(option),
                    "aussie-made-button": isAussieMade(option)
                })
            }
            onClick={() => onChange(option)}
            onKeyPress={onKeyPress}
        >
            <strong className="PaSelectOption__Label">
                {optionName}
                {_isPackagedPrintsPaperType() && (
                    <span style={{'display': 'block', 'fontSize': 'smaller', 'marginTop': '5px'}}>
                        Qty x {_getQtySetByOptionValue(option.value)} required
                    </span>
                )}
            </strong>
        </li>
    )
}

const SelectType = ({attribute, value, onChange}) => {
    const {
        setHoveredAttribute,
        setShowHoveredAttribute,
        checkOptionLogic
    } = useContext(OrderFormContext)

    const [options, setOptions] = useState([])
    const [visibleOptions, setVisibleOptions] = useState([])

    useEffect(() => {
        setOptions(attribute.options || [])
    }, [attribute])

    useEffect(() => {
        setVisibleOptions(options.filter(option => checkOptionLogic(option)))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options])

    const _onChangeValue = (option) => onChange(option.value)
    const _isSelected = (option) => {
        return value === option.value
    }

    const _isGrayOut = (option) => value && !_isSelected(option)

    const _isAussieMade = option => true === option.aussie

    const _onUpdateHoveredAttribute = (option) => {
        setShowHoveredAttribute(true)
        setHoveredAttribute(option)
    }

    const _onCloseHoverAttribute = () => setShowHoveredAttribute(false)

    return (
        <ul className="PaSelectOptions">
            {visibleOptions && visibleOptions.map((option, index) =>
                <SelectOption
                    key={index}
                    option={option}
                    isSelected={_isSelected}
                    isGrayOut={_isGrayOut}
                    onChange={_onChangeValue}
                    onHover={_onUpdateHoveredAttribute}
                    onLeave={_onCloseHoverAttribute}
                    isAussieMade={_isAussieMade}
                    attributeCode={attribute.code}
                />
            )}
        </ul>
    )
}

SelectType.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    attribute: PropTypes.object.isRequired
}

SelectOption.propTypes = {
    option: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    isSelected: PropTypes.func.isRequired,
    isGrayOut: PropTypes.func.isRequired,
    onHover: PropTypes.func.isRequired,
    onLeave: PropTypes.func.isRequired,
    isAussieMade: PropTypes.func.isRequired
}

export default SelectType
